export const common = {
  namespaced: true,
  state: {
    tabKey: 'zixun',
    tabIndex: 0,
    tabs: [
      {
        label: '资讯',
        list: [],
        pageNo: 0,
        pageSize: 20,
        key: 'zixun'
      },
      {
        label: '公告',
        list: [],
        pageNo: 0,
        pageSize: 20,
        key: 'gonggao'
      },
      {
        label: '研报',
        list: [],
        pageNo: 0,
        pageSize: 20,
        key: 'yanbao'
      },
      {
        label: '简况',
        list: [],
        pageNo: 0,
        key: 'jiankuang'
      },
      {
        label: '财务',
        key: 'caiwu'
      },
      {
        label: '股圈',
        key: 'guba',
        list: [],
        pageNo: 1,
      }
    ]
  },
  mutations: {
    setTabKey(state, val) { state.tabKey = val },
    setTabs(state, val) { state.tabs = val },
    setTabIndex(state, val) { state.tabIndex = val }
  }
}
